/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBREVENUENEW = 'GETCLUBREVENUENEW'
export const GETPERIOD = 'GETPERIOD'



// WEBPACK FOOTER //
// ./src/containers/ClubRevenueNew/constants.js